import Graphic = require("esri/Graphic");
import MapView = require("esri/views/MapView");

import ColumnHider = require("dgrid/extensions/ColumnHider");
import OnDemandGrid = require("dgrid/OnDemandGrid");
import Selection = require("dgrid/Selection");
import StoreAdapter = require("dojo-dstore/legacy/StoreAdapter");
import Memory = require("dojo/store/Memory");

import Tooltip = require("dijit/Tooltip");

import { Geometry } from "esri/geometry";
import FeatureLayer = require("esri/layers/FeatureLayer");
import MapImageLayer = require("esri/layers/MapImageLayer");
import Sublayer = require("esri/layers/support/Sublayer");
import { SimpleFillSymbol, SimpleLineSymbol, SimpleMarkerSymbol } from "esri/symbols";
import Query = require("esri/rest/support/Query");
import * as layerSource from "../../data/Layers/layerSource";
import * as pavement from "../../data/Layers/pavement";
import ToolButton from "./toolButton";
import { clearGraphicType, highlightColor } from "../App/setupView";
import GraphicsLayer = require("esri/layers/GraphicsLayer");

// SelectionResultTable

export const finalPolygon = new SimpleLineSymbol({
  color: [255, 0, 0],
  style: "solid",
  width: 2
});

export const drawingPolygon = new SimpleFillSymbol({
  color: [178, 25, 25, 0.2],
  style: "solid",
  outline: {
    color: [255, 0, 0],
    width: 2
  }
});

export default class SelectionResultTable {
  grid: any;
  private featureCount: HTMLElement;
  private view: MapView;
  private dataStore: any;
  private gridFields: any;
  private drawLayer: GraphicsLayer;
  private gridDisplayDiv: HTMLElement;
  private closeButton: HTMLDivElement;
  private viewSelectedDiv: HTMLDivElement;
  private viewSelected: HTMLInputElement;
  private selectLayerList: HTMLSelectElement;
  private selectedGraphic: Graphic;

  constructor(toolIn: ToolButton) {
    this.view = toolIn.view;
    this.drawLayer = this.view.map.findLayerById("drawLayer") as GraphicsLayer;
    this.gridDisplayDiv = document.getElementById("gridDisplay") as HTMLElement;
    this.featureCount = document.getElementById("featureCount") as HTMLElement;
    this.closeButton = document.getElementById("gridTitleBarCloseButton") as HTMLDivElement;
    if (this.closeButton) {
      this.closeButton.onclick = () => {
        this.hideResultsTable();
      };
    }
  }

  /****************************************************
   * Selects features from the csv layer that intersect
   * a polygon that user drew using sketch view model
   ****************************************************/
  selectFeatures(inGeometry: Geometry) {
    try {
      // console.log("  selectFeatures");

      this.selectLayerList = document.getElementById("selectLayerList") as HTMLSelectElement;
      this.closeButton = document.getElementById("gridTitleBarCloseButton") as HTMLDivElement;
      if (this.closeButton) {
        this.closeButton.onclick = () => {
          this.hideResultsTable();
        };
      }

      this.viewSelectedDiv = document.getElementById("zoomToSelected") as HTMLDivElement;
      this.viewSelectedDiv.innerHTML = "<input type='checkbox' checked id='zoomToSelectedCheckbox'>Zoom To Selected";
      this.viewSelected = document.getElementById("zoomToSelectedCheckbox") as HTMLInputElement;
      const layerId: any = this.selectLayerList.value;
      const layerTitle: string = this.selectLayerList[this.selectLayerList.selectedIndex].label;

      this.clearGrid();
      if (this.featureCount) {
        this.featureCount.innerHTML = "<b>Searching...</b>";
      }

      this.view.padding = { bottom: this.gridDisplayDiv.clientHeight }; // Same value as the #gridDiv height in CSS
      this.gridDisplayDiv.style.visibility = "block";
      this.gridDisplayDiv.style.zIndex = "80";

      const layer: __esri.Layer = this.view.map.findLayerById(layerId);

      if (layer) {
        this.gridFields = [] as string[];

        const query = new Query({
          geometry: inGeometry,
          outFields: ["*"]
        });

        if (layer instanceof MapImageLayer) {
          const mapImageLayer: MapImageLayer = layer as MapImageLayer;
          if (mapImageLayer && mapImageLayer.sublayers.length > 0) {
            let mapImageSelectedLayer = mapImageLayer.sublayers.getItemAt(0);
            // If it's one of the program layers, use the 3rd layer as the selectable layer (i.e. CRS Marked);
            if (mapImageLayer.sublayers.length > 2) {
              mapImageSelectedLayer = mapImageLayer.sublayers.getItemAt(1);
            }
            if (mapImageSelectedLayer) {
              // console.log("  Sublayer = ", mapImageSelectedLayer.title);
              document.body.style.cursor = "wait";
              mapImageSelectedLayer
                .queryFeatures(query)
                .then(({ features, fields }) => {
                  this.loadGrid(features, fields, mapImageSelectedLayer, layerTitle);
                })
                .catch(this.errorCallback);
            }
          }
        } else if (layer instanceof FeatureLayer) {
          const featureLayer = layer as FeatureLayer;
          // console.log("  featureLayer = ", featureLayer.title, " layerId = ", featureLayer.id);
          // console.log("   selectLayerList = ", this.selectLayerList)
          if (featureLayer.layerId === layerSource.RoadConditionQueryLayer ) {
            switch (this.selectLayerList.options[this.selectLayerList.selectedIndex].text) {
              case "CRS Marked" : 
                query.where = "(CRS_LOW > 0.99) and (Marked_rt <> '') and (Key_rt_app <> '4' ) and (Key_rt_app <> '7')";
                query.outFields = pavement.crsFields;
                break;
              case "CRS Unmarked" :
                query.where = "(CRS_LOW > 0.99) and (Marked_rt = '') and (Key_rt_app <> '4' ) and (Key_rt_app <> '7')";
                query.outFields = pavement.crsFields;
                break;
              case "IRI Marked" :
                query.where = "(IRI_LOW > 0) and (Marked_rt <> '') and (Key_rt_app <> '4' ) and (Key_rt_app <> '7')";
                query.outFields = pavement.iriFields;
                break;
              case "IRI Unmarked" :
                query.where = "(IRI_LOW > 0) and (Marked_rt = '') and (Key_rt_app <> '4' ) and (Key_rt_app <> '7')";
                query.outFields = pavement.iriFields;
                break;
              case "Rutting Marked" :
                query.where = "(RUT_LOW > 0) and (Marked_rt <> '') and (Key_rt_app <> '4' ) and (Key_rt_app <> '7')";
                query.outFields = pavement.rutFields;
                break;
              case "Rutting Unarked" :
                query.where = "(RUT_LOW > 0) and (Marked_rt = '') and (Key_rt_app <> '4' ) and (Key_rt_app <> '7')";
                query.outFields = pavement.rutFields;
                break;
            }
          }
          document.body.style.cursor = "wait";
          featureLayer
            .queryFeatures(query)
            .then(({ features, fields }) => {
              this.loadGrid(features, fields, featureLayer, layerTitle);
            })
            .catch(this.errorCallback);
        } else {
          if (this.featureCount) {
            this.featureCount.innerHTML = "<b>Selection Layer is not set.</b>";
          }
        }
      } else {
        if (this.featureCount) {
          this.featureCount.innerHTML = "<b>Selection Layer is not set.</b>";
        }
      }
    } catch (error) {
      console.error("Error: in selectFeatures " + error.message);
    }
  }

  loadGrid(features: Graphic[], fields: __esri.Field[], selectedLayer: any, title:string) {
    try {
      if (this.featureCount) {
        this.featureCount.innerHTML =
          "<b>" + title + " Search Results (" + features.length.toString() + ") </b>";
      }

      // if the grid div is displayed while query results does not
      // return graphics then hide the grid div and show the instructions div
      if (features.length > 0) {
        // Add all fields available to the results table
        // this.gridFields = [] as string[];
        // fields.forEach(field => {
        //     this.gridFields.push(field.name);
        // });

        if (this.gridFields.length === 0) {
          fields.forEach(field => {
            this.gridFields.push(field.name);
          });
        }

        // get the attributes to display in the grid
        const data = features.map((feature, i) => {
          return (
            Object.keys(feature.attributes)
              .filter(key => {
                // get fields that exist in the grid
                return this.gridFields.indexOf(key) !== -1;
              })
              // need to create key value pairs from the feature
              // attributes so that info can be displayed in the grid
              .reduce((obj, key) => {
                obj[key] = feature.attributes[key];
                return obj;
              }, {})
          );
        });

        let oidField = "";
        for (const field of fields) {
          if (field.type === "oid") {
            oidField = field.name;
            break;
          }
        }

        // set the datastore for the grid using the
        // attributes we got for the query results
        this.dataStore = new StoreAdapter({
          objectStore: new Memory({
            idProperty: oidField
          })
        });
        this.dataStore.objectStore.data = data;
        this.createGrid(fields, selectedLayer);
        this.grid.set("collection", this.dataStore);
      }
      document.body.style.cursor = "default";
    } catch (error) {
      console.error("Error: in loadGrid " + error.message);
    }
  }

  toggleResultsTable() {
    // console.log ("gridDisplayDiv = ", this.gridDisplayDiv)
    if (this.gridDisplayDiv) {
      const zindex = parseInt(this.gridDisplayDiv.style.zIndex as string, 10);
      if (zindex !== 80) {
        // if invisible
        this.view.padding = { bottom: this.gridDisplayDiv.clientHeight }; // Same value as the #gridDiv height in CSS
        this.gridDisplayDiv.style.visibility = "block";
        this.gridDisplayDiv.style.zIndex = "80";
      } else {
        this.gridDisplayDiv.style.visibility = "none";
        this.gridDisplayDiv.style.zIndex = "-80";
        this.view.padding = { bottom: 0 }; // Same value as the #gridDiv height in CSS
      }
    }
  }

  hideResultsTable() {
    if (this.gridDisplayDiv) {
      this.gridDisplayDiv.style.visibility = "none";
      this.gridDisplayDiv.style.zIndex = "-80";
      this.view.padding = { bottom: 0 }; // Same value as the #gridDiv height in CSS
    }
  }

  clearGrid() {
    try {
      // console.log ("clearGrid");

      this.clearUpSelection();

      const gridDiv = document.getElementById("grid") as HTMLElement;
      if (gridDiv) {
        gridDiv.innerHTML = "";
      }

      if (this.featureCount) {
        this.featureCount.innerHTML = "";
      }

      if (this.grid) {
        this.grid = null;
      }
    } catch (error) {
      console.error("Error: in clearGrid " + error.message);
    }
  }

  clearUpSelection() {
    try {
      // console.log ("clearUpSelection");
      clearGraphicType(this.view, "selected");
      if (this.grid) {
        this.grid.clearSelection();
      }
    } catch (error) {
      console.error("Error: in clearupSelection " + error.message);
    }
  }
  /************************************************
   * Creates a new grid. Loops through poverty
   * csvLayer's fields and creates grid columns
   * Grid with selection and columnhider extensions
   *************************************************/
  private createGrid(fields: __esri.Field[], selectedLayer: any) {
    try {
      // console.log("createGrid");

      const columnsUsed = fields
        .filter((field, i) => {
          if (this.gridFields.indexOf(field.name) !== -1) {
            return field;
          }
        })
        .map(field => {
          if (
            field.name.toUpperCase().indexOf("OBJECTID") === 0 ||
            field.type === "oid" ||
            field.name.toUpperCase().indexOf("SHAPE") === 0
          ) {
            return {
              field: field.name,
              label: field.name,
              sortable: true,
              hidden: true
            };
          } else {
            return {
              field: field.name,
              label: field.alias,
              sortable: true
            };
          }
        });

      // create a new onDemandGrid with its selection and columnhider
      // extensions. Set the columns of the grid to display attributes
      // the hurricanes cvslayer
      this.grid = new (OnDemandGrid.createSubclass([Selection, ColumnHider]))(
        {
          columns: columnsUsed,
          selectionMode: "single"
        },
        "grid"
      );

      // this.grid.on(".dgrid-cell:mouseenter")
      this.grid.on(".dgrid-cell:mouseover", (event: any) => {
        const cell = this.grid.cell(event);
        if (cell && cell.row && cell.row.data && cell.element && cell.element.offsetWidth < cell.element.scrollWidth) {
          // console.log ("cell mouseover ", cell.row.data[cell.column.label] );
          Tooltip.show(cell.row.data[cell.column.label], cell.element);
        }
      });

      this.grid.on(".dgrid-cell:mouseout", (event: any) => {
        const cell = this.grid.cell(event);
        if (cell && cell.row && cell.row.data && cell.element && cell.element.offsetWidth < cell.element.scrollWidth) {
          // console.log ("cell mouseout ", cell.row.data[cell.column.label]);
          Tooltip.hide(cell.element);
        }
      });

      // add a row-click listener on the grid. This will be used
      // to highlight the corresponding feature on the view
      this.grid.on("dgrid-select", (event: any) => {
        // console.log("grid.on dgrid-select");

        if (this.selectedGraphic) {
          this.drawLayer.remove(this.selectedGraphic);
        }
        // close view popup if it is open
        this.view.popup.close();

        // get the ObjectID value from the clicked row
        const row = event.rows[0];
        const id = row.data[this.dataStore.objectStore.idProperty];

        // setup a query by specifying objectIds
        const query = {
          objectIds: [parseInt(id, 10)],
          outFields: ["*"],
          returnGeometry: true
        };

        if (selectedLayer instanceof Sublayer) {
          selectedLayer
            .queryFeatures(query)
            .then(results => {
              this.selectRow(results);
            })
            .catch(this.errorCallback);
        } else if (selectedLayer instanceof FeatureLayer) {
          selectedLayer
            .queryFeatures(query)
            .then(results => {
              this.selectRow(results);
            })
            .catch(this.errorCallback);
        }
        // query the csvLayerView using the query set above
      });
    } catch (error) {
      console.error("Error: in createGrid " + error.message);
    }
  }

  private selectRow(results: __esri.FeatureSet) {
    try {
      if (results && results.features && results.features.length > 0) {
        const graphics = results.features;
        // remove all graphics to make sure no selected graphics
        clearGraphicType(this.view, "selected");

        const newGeometry: __esri.Geometry = graphics[0].geometry;
        if (newGeometry.extent) {
          this.selectedGraphic = new Graphic({
            geometry: newGeometry,
            attributes: { type: "selected" },
            symbol: new SimpleLineSymbol({
              color: highlightColor,
              width: 5 // points
            })
          });
          this.drawLayer.add(this.selectedGraphic);
          if (this.viewSelected.checked) {
            this.view.goTo(this.selectedGraphic.geometry.extent.expand(2));
          }
        } else {
          this.selectedGraphic = new Graphic({
            geometry: newGeometry,
            attributes: { type: "selected" },
            symbol: new SimpleMarkerSymbol({
              style: "circle",
              color: "orange",
              size: "5px",
              outline: {
                color: [255, 255, 0],
                width: 3
              }
            })
          });
          this.drawLayer.add(this.selectedGraphic);
          if (this.viewSelected.checked) {
            this.view.goTo({
              target: this.selectedGraphic.geometry,
              zoom: 12
            });
          }
        }
      }
    } catch (error) {
      console.error("Error: in selectRow " + error.message);
    }
  }

  private errorCallback(error: Error) {
    console.error("error:", error);
    document.body.style.cursor = "default";
    if (this.featureCount) {
      this.featureCount.innerHTML = "<b>Error: No features returned</b>";
    }
  }
}
